import { ChangeEvent } from 'react';
import { FormState } from 'react-hook-form';

import { PLCustomerData } from 'types';
import { GaFunnelInfo } from 'types/gaFunnelInfo';
import { trackEvent } from 'utils/trackEvent';

type PLCustomerField = keyof PLCustomerData;

export const handleFormGaEvent = (
	fieldName: PLCustomerField,
	formState: FormState<PLCustomerData>,
	event: ChangeEvent<HTMLInputElement>,
	gaFunnelInfo: GaFunnelInfo | object
) => {
	const value = event?.target?.value || '';
	const errorObject = formState.errors[fieldName];

	let errorMessage = '';
	if (errorObject) {
		errorMessage = errorObject.message || '';
	}

	if (value) {
		trackEvent({
			event: 'user_interaction',
			type: 'form',
			component: 'form-field',
			field: fieldName,
			action: 'change',
			category: 'persoonlijke-gegevens',
			status: errorMessage ? `invalid: ${errorMessage}` : 'valid',
			...gaFunnelInfo,
		});
	}
};
